import React, { useState, useEffect } from "react";
import Logo from "../../../assets/image/logo-image.png";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { storage } from "../../../utils/auth";
import { Spinner } from "react-bootstrap";

const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

function ExhibitorLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showOTPField, setShowOTPField] = useState(false);
  const [loginBackground, setLoginBackground] = useState("");
  const [loginBackgroundColor, setLoginBackgroundColor] = useState("");
  const [brandingLogo, setBrandingLogo] = useState("");

  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const userType = pathname.split("/")[1];
  const exhibitorAgentType = userType;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleChange();
    }
  };

  useEffect(() => {
    if (storage.get("token", userType)) {
      navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`);
    }

    axios
      .get(`${process.env.REACT_APP_API_END_POINT}/get-registration-visibility`)
      .then((res) => {
        if (res.data.data) {
          if (res.data.data.login_background) { setLoginBackground(res.data.data.login_background); }
          if (res.data.data.login_background_color) { setLoginBackgroundColor(res.data.data.login_background_color); }
          if (res.data.data.branding_logo) {
            setBrandingLogo(res.data.data.branding_logo);
          }
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const loginBGStyle = loginBackground
    ? {
      backgroundImage: `url("${process.env.REACT_APP_IMAGE_URL}/branding/${loginBackground}")`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundColor: loginBackgroundColor || "#ee272a",
      backgroundPosition: "center",
      width: "100%",
    }
    : {};

  const logoSrc = brandingLogo
    ? `${process.env.REACT_APP_IMAGE_URL}/branding/${brandingLogo}`
    : Logo;

  const handleChange = async () => {
    setIsLoading(true);
    if (!email) {
      message.error("Enter username, email or mobile number");
      setIsLoading(false);
      return;
    }

    if (!password) {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_END_POINT}/generate-otp`, {
          email,
        });

        if (response?.data?.success) {
          setShowOTPField(true);
          message.success("OTP sent successfully");
        } else {
          message.error(response?.data?.message || "Failed to generate OTP");
        }
      } catch (error) {
        message.error("Error generating OTP");
      }
      setIsLoading(false);
      return;
    } else {
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/login`, {
          email,
          password,
          requiredRole: "exhibitor"
        })
        .then((response) => {
          // insert token in localstorage
          storage.set("permission", JSON.stringify(response.data.category.permissions), userType);
          storage.set("token", response.data.token, userType);
          storage.set("user_id", response.data.category._id, userType);
          storage.set("type_of_user", `/${exhibitorAgentType.toLowerCase()}/login`, userType);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        })
        .finally(() => {
          let data = storage.get("permission", userType);
          data = JSON.parse(data);

          console.log("data", data);

          let nameArray = [];

          // console.log("ssdsssasdasa",data[i])
          axios
            .post(
              `${process.env.REACT_APP_API_END_POINT}/get-permission-name`,
              {
                permission: data,
              }
            )
            .then((res) => {
              console.log(".data.data", res.data.data);
              nameArray = res.data.data;

              if (nameArray.includes("exhibitor")) {
                console.log("running inside if");
                navigate(`/${exhibitorAgentType.toLowerCase()}/dashboard`);
              } else {
                message.error("Access Denied");
              }
            });
        });
    }
  };

  return (
    <>
      <div className="kcebg" style={loginBGStyle}>
        <div className="exhibitorlogin">
          <div className="exhibitorloginbody">
            <Form className="my-4" onSubmit={(e) => e.preventDefault()}>
              <Form.Control
                type="username"
                placeholder="Enter your Phone Number"
                className="my-4"
                onChange={(e) => setEmail(e.target.value)}
                required
                onKeyDown={handleKeyDown}
              />

              {showOTPField &&
                <Form.Control
                  type="password"
                  id="inputPassword5"
                  aria-describedby="passwordHelpBlock"
                  placeholder="Enter the OTP"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  onKeyDown={handleKeyDown}
                />
              }

              <Button className="my-4 btn-block" onClick={handleChange}>
                {isLoading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExhibitorLogin;
